import { withTranslation } from "react-i18next";
import { classScheduleType } from "../../../utils/classScheduleType";
import { classTextSchedule } from "../../../utils/classTextSchedule";
import { getText } from "../../../utils/getText";
import { timeSchedule } from "../../../utils/timeSchedule";

function DisponibilidadCardInfo({t,item, setTimeAppointment, admindoctor}){
    const razons = {
        RETRO: 'En retroalimentación',
        COMIDA: 'En comida',
        PERSONAL_TIME: 'En tiempo personal',
        CAPACITACION: 'En capacitación',
        INCAPACIDAD: 'Incapacidad',
        DIA_DESCANDO: 'Día de descanso',
        ADMIN: 'Administrativo',
        FUERA_HORARIO: 'Fuera de horario'
    }

    return(

        <div className="section-schedule">
            <div className="d-flex align-items-center mb-2">
                <div className={`view-info mr-2 ${classScheduleType(item.scheduleType.id, item)}`} onClick={e=>setTimeAppointment(item)}>
                    <div className="view-info-content">
                        <div>
                            {
                                item.scheduleType.id !== 'Blocked' &&
                                <span className={`${classTextSchedule(item.scheduleType.id, item)} font-size-08rem font-weight-bold-600 mr-2`}>
                                    {getText(item.scheduleType.id, item)}
                                </span>
                            } 
                            <span className="font-size-08rem text-muted">
                                {timeSchedule(item)} {item?.appointment?.appointmentStatus === "NoAtendida" && ' - No atendida'}
                            </span>
                        </div>
                        <div>
                            {
                                item.scheduleType.id === 'Blocked' ?
                                <label className="m-0 font-weight-bold-600 font-size-09rem text-dark">No disponible - {razons[item.scheduleType?.name]}</label> :
                                <label className="m-0 font-weight-bold-600 font-size-09rem text-dark">
                                    {
                                        (item.appointment?.patientDTO?.name !== null && item.appointment?.patientDTO?.name !== "") ?
                                        `${item.appointment?.patientDTO?.name ?? ''} ${item.appointment?.patientDTO?.middleName ?? ''} ${item.appointment?.patientDTO?.lastName ?? ''} ${item.appointment?.patientDTO?.seccondSurname ?? ''}` :
                                        item?.appointment?.patientDTO?.email ?? ''
                                    }
                                </label>
                            }                            
                        </div>
                    </div>
                </div>
                {/* {admindoctor && 
                <div
                    className={`${item?.appointment && item?.token_conference !== 'N/A' ? '' : 'text-disabled'}`}
                >
                    <FaAlignJustify 
                        onClick={
                            item?.appointment && item?.token_conference !== 'N/A' ?
                            spyAppointment :
                            () => {}
                        }
                    />
                </div>} */}
            </div>
        </div>
    )

}

export default withTranslation()(DisponibilidadCardInfo)